import { peticionesReceiver } from "../../../helpers/peticionesReceiver";
import Notification from "../../../components/Notification/Notification";
import { toast } from "react-toastify";
const API = peticionesReceiver();

export const agregar = async (carrera) => {
    const data = {
      action: "insert",
      table: "careertypes",
      rows: carrera,
      validate: [
        ["nameCareerType", "careerTitle"],
    ]
    };    
    API.peticion(data).then((res) => {
        if (res.status === 200 && res.data.code === "200") {
          console.log("Insertado",res)
          toast(<Notification type={"agrega_exito"} backMessage={res.data.message} withIcon />);
          window.location.href = "#/template/carreras";
        } else {
          console.log("Insertado",res)
          toast(<Notification type={"agrega_error"} backMessage={res.data.message} withIcon />);
        }
      })
      .catch((err) => {
        toast(<Notification type={"consultar_servidor_error"} withIcon />);
      });
  };

export const editar = async (carrera) => {
    const data = {
      action: "update",
      table: "careertypes",
      rows: carrera,
      condition: {
        keyCareerType: carrera.keyCareerType,
      },
      validate: [
        ["nameCareerType", "careerTitle"],
    ]
    };
    
    API.peticion(data).then((res) => {
        if (res.status === 200 && res.data.code === "200") {
          toast(<Notification type={"modifica_exito"} backMessage={res.data.message} withIcon />);
          window.location.href = "#/template/carreras";
        } else {
          toast(<Notification type={"modifica_error"} backMessage={res.data.message} withIcon />);
        }
      })
      .catch((err) => {
        toast(<Notification type={"consultar_servidor_error"} withIcon />);
      });
  };
